import React, { ReactNode } from 'react';
import { withTranslation } from 'react-i18next';
import { Box, Button, Modal, SxProps, Typography } from '@mui/material';

import { IConfirmModalView } from '../interfaces';

import { useStyles } from './styles';
import { useModalStyles } from '@core/myta/hooks/modalStyles';
import { CloseIcon } from '@icons';

const ConfirmModalAltView = ({
  title = '',
  message,
  open,
  onCancel,
  onConfirm,
  confirmButtonName,
  cancelButtonName,
  onCancelAltAction,
  hideCloseButton,
  children,
  sx,
}: IConfirmModalView) => {
  const modalClasses = useModalStyles();

  const classes = useStyles();

  const secondaryButtonSx = {
    ...modalClasses.button,
    ...modalClasses.buttonSecondary,
    ...classes.button,
    ...classes.secondaryButton,
  };
  const primaryButtonSx = {
    ...modalClasses.button,
    ...modalClasses.buttonPrimary,
    ...classes.button,
  };

  return (
    <Modal open={open} hideBackdrop sx={sx?.root}>
      <Box
        component="div"
        sx={{
          ...modalClasses.container,
          ...classes.container,
        }}
      >
        {!hideCloseButton && (
          <CloseIcon sx={classes.close} onClick={onCancel} />
        )}
        {title ? <Typography sx={classes.title}>{title}</Typography> : null}
        <Typography sx={classes.message}>{message}</Typography>
        <Box
          component="div"
          sx={{ ...classes.actions, ...sx?.actions } as SxProps}
        >
          {children}
          {onCancel ? (
            <Button
              onClick={onCancelAltAction || onCancel}
              variant="outlined"
              sx={secondaryButtonSx}
            >
              {cancelButtonName || 'No'}
            </Button>
          ) : null}
          {onConfirm ? (
            <Button onClick={onConfirm} variant="outlined" sx={primaryButtonSx}>
              {confirmButtonName || 'Yes'}
            </Button>
          ) : null}
        </Box>
      </Box>
    </Modal>
  );
};

export default withTranslation()(ConfirmModalAltView);
